import {useState} from 'react';
import type {Schema} from './api';
import {readinessLine} from './resourcePrice';
import {estimateRequests} from './estimateAttention';
import './estimate-actions.css';

/** Три раздельных состояния сметы и перечень того, что сметчик запрашивает у заказчика. */
export function EstimateReadiness({data,historical=false}:{data:Schema['FullEstimate'];historical?:boolean}) {
  const [copied,setCopied]=useState('');
  const states=data.readiness??[],requests=data.requests??[];
  const {missing,received}=estimateRequests(requests);
  if(!states.length&&!requests.length)return null;
  async function copy() {
    try{await navigator.clipboard.writeText(data.request_text??'');setCopied('Запрос скопирован');}
    catch{setCopied('Не удалось скопировать: выделите текст запроса вручную');}
  }
  return <>
    <div className="estimate-readiness" aria-label="Готовность сметы">
      {states.map(item=>{const line=readinessLine(item);return <div key={item.key} className={line.tone}>
        <strong>{line.text}</strong>{item.detail&&<p>{item.detail}</p>}</div>;})}
    </div>
    {requests.length>0&&<div className="estimate-request-groups">
      {historical&&<p className="muted">Сведения на момент сохранения снимка, не текущий запрос заказчику.</p>}
      {missing.length>0&&<section className="estimate-request-group estimate-request-group--missing">
        <h3>{historical?'Не было получено':'Получить у заказчика'} · {missing.length}</h3>
        {missing.map((r,index)=><details key={`${r.key}:${index}`} className="estimate-request-item"><summary>
          <span className={`estimate-action-label estimate-action-label--${historical?'neutral':'amber'}`}>{historical?'В снимке не получено':'Запросить'}</span>{r.label}
        </summary><p>{r.question}</p></details>)}
      </section>}
      {received.length>0&&<details className="estimate-request-group"><summary>{historical?'Было получено':'Получено'} · {received.length}</summary>
        {received.map((r,index)=><div className="estimate-request-item" key={`${r.key}:${index}`}><strong>{r.label}</strong><p>{r.value}</p></div>)}
      </details>}
      {data.request_text&&<details className="cost-limitations estimate-requests"><summary>{historical?'Сохранённый текст запроса':'Текст запроса заказчику'}</summary><pre style={{whiteSpace:'pre-wrap'}}>{data.request_text}</pre>
        <button type="button" className="button small" onClick={()=>void copy()}>Скопировать запрос</button>
        {copied&&<span role="status"> {copied}</span>}</details>}
    </div>}
  </>;
}
